// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Promise = require("@rescript/runtime/lib/js/Stdlib_Promise.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function make(fn) {
  return fn;
}

function noop() {
  
}

function unsubscribe(t) {
  if (!t.closed) {
    t.closed = true;
    return t.unsubscribe();
  }
}

function make$1(unsubscribe) {
  return {
    unsubscribe: unsubscribe,
    closed: false
  };
}

let Subscription = {
  unsubscribe: unsubscribe,
  make: make$1
};

function shouldStop(e) {
  if (typeof e !== "object") {
    return true;
  } else {
    return e.TAG !== "Next";
  }
}

let Event = {
  shouldStop: shouldStop
};

function make$2(fn) {
  return fn;
}

function on(event, t) {
  return t(event);
}

function next(v, t) {
  t({
    TAG: "Next",
    _0: v
  });
}

function emit(event, t) {
  if (!t.stopped) {
    t.stopped = shouldStop(event);
    return t.emit(event);
  }
}

function unsubscribe$1(t) {
  t.stopped = true;
}

function make$3(emit) {
  return {
    emit: emit,
    stopped: false
  };
}

function next$1(v, t) {
  emit({
    TAG: "Next",
    _0: v
  }, t);
}

function complete(t) {
  emit("Complete", t);
}

function error(e, t) {
  emit({
    TAG: "Error",
    _0: e
  }, t);
}

let Emitter_Observer = {
  make: make$2,
  on: on
};

let Emitter = {
  Event: Event,
  emit: emit,
  Observer: Emitter_Observer,
  make: make$3,
  unsubscribe: unsubscribe$1
};

function onSubscribe(emitter, t) {
  return t(emitter);
}

function make$4(fn) {
  return fn;
}

let Source = {
  Emitter: Emitter,
  make: make$4,
  onSubscribe: onSubscribe
};

let include = (Source => {
  let make$5 = source => ({
    source: source
  });
  let fromFn = fn => make$5(Source.make(fn));
  let subscribe = (observer, t) => {
    let emitter = make$3(observer);
    let subscription = Source.onSubscribe(emitter, t.source);
    return {
      unsubscribe: () => {
        unsubscribe$1(emitter);
        subscription();
      },
      closed: false
    };
  };
  let subscribeFn = (fn, t) => subscribe(make$2(fn), t);
  return {
    make: make$5,
    fromFn: fromFn,
    subscribe: subscribe,
    subscribeFn: subscribeFn
  };
})(Source);

let fromFn = include.fromFn;

let subscribe = include.subscribe;

let subscribeFn = include.subscribeFn;

function fromPromise(promise) {
  return fromFn(emitter => {
    Stdlib_Promise.$$catch(promise.then(result => {
      emit({
        TAG: "Next",
        _0: result
      }, emitter);
      emit("Complete", emitter);
      return Promise.resolve();
    }), err => {
      emit({
        TAG: "Error",
        _0: err
      }, emitter);
      return Promise.resolve();
    });
    return noop;
  });
}

function onNext(onCompleteOpt, onErrorOpt, onNext$1, t) {
  let onComplete = onCompleteOpt !== undefined ? onCompleteOpt : () => {};
  let onError = onErrorOpt !== undefined ? onErrorOpt : param => {};
  return subscribeFn(event => {
    if (typeof event !== "object") {
      return onComplete();
    } else if (event.TAG === "Next") {
      return onNext$1(event._0);
    } else {
      return onError(event._0);
    }
  }, t);
}

function shouldStop$1(param) {
  return true;
}

let Event$1 = {
  shouldStop: shouldStop$1
};

function make$5(fn) {
  return fn;
}

function on$1(event, t) {
  return t(event);
}

function emit$1(event, t) {
  if (t.stopped) {
    return;
  }
  t.stopped = Event$1.shouldStop(event);
  let __x = t.emit;
  on$1(event, __x);
}

function unsubscribe$2(t) {
  t.stopped = true;
}

function make$6(emit) {
  return {
    emit: emit,
    stopped: false
  };
}

function ok(v, e) {
  emit$1({
    TAG: "Ok",
    _0: v
  }, e);
}

let Emitter_Observer$1 = {
  make: make$5,
  on: on$1
};

let Emitter$1 = {
  Event: Event$1,
  emit: emit$1,
  Observer: Emitter_Observer$1,
  make: make$6,
  unsubscribe: unsubscribe$2
};

function onSubscribe$1(emitter, t) {
  return t(emitter);
}

function make$7(fn) {
  return fn;
}

let Source$1 = {
  Emitter: Emitter$1,
  make: make$7,
  onSubscribe: onSubscribe$1
};

let include$1 = (Source => {
  let make$8 = source => ({
    source: source
  });
  let fromFn = fn => make$8(Source.make(fn));
  let subscribe = (observer, t) => {
    let emitter = make$6(observer);
    let subscription = Source.onSubscribe(emitter, t.source);
    return {
      unsubscribe: () => {
        unsubscribe$2(emitter);
        subscription();
      },
      closed: false
    };
  };
  let subscribeFn = (fn, t) => subscribe(make$5(fn), t);
  return {
    make: make$8,
    fromFn: fromFn,
    subscribe: subscribe,
    subscribeFn: subscribeFn
  };
})(Source$1);

let fromFn$1 = include$1.fromFn;

function fromPromise$1(promise) {
  return fromFn$1(emitter => {
    Stdlib_Promise.$$catch(promise.then(result => {
      emit$1({
        TAG: "Ok",
        _0: result
      }, emitter);
      return Promise.resolve();
    }), err => {
      emit$1({
        TAG: "Error",
        _0: err
      }, emitter);
      return Promise.resolve();
    });
    return noop;
  });
}

function observer(t) {
  return event => Stdlib_List.forEach(t.subscribers, extra => emit(event, extra));
}

function observable(t) {
  return fromFn(emitter => {
    t.subscribers = Stdlib_List.add(t.subscribers, emitter);
    return () => {
      t.subscribers = Stdlib_List.filter(t.subscribers, x => x !== emitter);
      emitter.stopped = true;
    };
  });
}

function make$8() {
  return {
    subscribers: /* [] */0
  };
}

let Subject = {
  observer: observer,
  observable: observable,
  make: make$8
};

function lift(fn, observable) {
  return fromFn(emitter => {
    let observer = fn(emitter);
    let subscription = subscribeFn(observer, observable);
    return () => unsubscribe(subscription);
  });
}

function last(observable) {
  let result = {
    contents: undefined
  };
  return lift(emitter => (event => {
    if (typeof event === "object") {
      if (event.TAG === "Next") {
        result.contents = Primitive_option.some(event._0);
        return;
      } else {
        return emit({
          TAG: "Error",
          _0: event._0
        }, emitter);
      }
    }
    emit({
      TAG: "Next",
      _0: result.contents
    }, emitter);
    emit("Complete", emitter);
  }), observable);
}

function map(fn, observable) {
  return lift(emitter => (event => {
    if (typeof event !== "object") {
      return emit("Complete", emitter);
    }
    if (event.TAG !== "Next") {
      return emit({
        TAG: "Error",
        _0: event._0
      }, emitter);
    }
    let v = fn(event._0);
    emit({
      TAG: "Next",
      _0: v
    }, emitter);
  }), observable);
}

function toArray(o) {
  let fn = (acc, x) => acc.concat([x]);
  let initial = [];
  let acc = {
    contents: initial
  };
  return lift(emitter => (event => {
    if (typeof event === "object") {
      if (event.TAG === "Next") {
        acc.contents = fn(acc.contents, event._0);
        return;
      } else {
        return emit({
          TAG: "Error",
          _0: event._0
        }, emitter);
      }
    }
    emit({
      TAG: "Next",
      _0: acc.contents
    }, emitter);
    emit("Complete", emitter);
  }), o);
}

function filter(fn, observable) {
  return lift(emitter => (event => {
    if (typeof event !== "object") {
      return emit("Complete", emitter);
    }
    if (event.TAG !== "Next") {
      return emit({
        TAG: "Error",
        _0: event._0
      }, emitter);
    }
    let value = event._0;
    if (fn(value)) {
      return emit({
        TAG: "Next",
        _0: value
      }, emitter);
    }
  }), observable);
}

function partition(fn, observable) {
  return [
    filter(fn, observable),
    filter(extra => !fn(extra), observable)
  ];
}

function defer(fn) {
  return fromFn(emitter => {
    let observable = fn();
    let subscription = subscribeFn(event => emit(event, emitter), observable);
    return () => unsubscribe(subscription);
  });
}

function flatMap(fn, observable) {
  return fromFn(emitter => {
    let subscription = subscribeFn(event => {
      if (typeof event !== "object") {
        return emit("Complete", emitter);
      }
      if (event.TAG !== "Next") {
        return emit({
          TAG: "Error",
          _0: event._0
        }, emitter);
      }
      let o = fn(event._0);
      subscribeFn(event => emit(event, emitter), o);
    }, observable);
    return () => unsubscribe(subscription);
  });
}

function publish(observable$1) {
  let subject = {
    subscribers: /* [] */0
  };
  let subscription = subscribe(observer(subject), observable$1);
  return fromFn(emitter => {
    let o = observable(subject);
    let subscription2 = subscribeFn(event => emit(event, emitter), o);
    return () => {
      unsubscribe(subscription2);
      unsubscribe(subscription);
    };
  });
}

function fromArray(arr) {
  return fromFn(emitter => {
    arr.forEach(e => emit({
      TAG: "Next",
      _0: e
    }, emitter));
    emit("Complete", emitter);
    return noop;
  });
}

let Unsubscriber = {
  noop: noop,
  make: make
};

let Observable_Event = {};

let Observable_Emitter = {
  emit: emit,
  next: next$1,
  complete: complete,
  error: error
};

let Observable_Source = {
  make: make$4
};

let Observable_Observer = {
  make: make$2,
  on: on,
  next: next
};

let Observable_make = include.make;

let Observable = {
  Event: Observable_Event,
  Emitter: Observable_Emitter,
  Source: Observable_Source,
  Observer: Observable_Observer,
  Subscription: Subscription,
  subscribe: subscribe,
  subscribeFn: subscribeFn,
  make: Observable_make,
  fromFn: fromFn,
  fromPromise: fromPromise,
  onNext: onNext
};

let Single_Event = {};

let Single_Emitter = {
  emit: emit$1,
  ok: ok
};

let Single_Source = {
  make: make$7
};

let Single_Observer = {
  make: make$5,
  on: on$1
};

let Single_subscribe = include$1.subscribe;

let Single_subscribeFn = include$1.subscribeFn;

let Single_make = include$1.make;

let Single = {
  Event: Single_Event,
  Emitter: Single_Emitter,
  Source: Single_Source,
  Observer: Single_Observer,
  Subscription: Subscription,
  subscribe: Single_subscribe,
  subscribeFn: Single_subscribeFn,
  make: Single_make,
  fromFn: fromFn$1,
  fromPromise: fromPromise$1
};

let Operators = {
  defer: defer,
  last: last,
  map: map,
  toArray: toArray,
  filter: filter,
  partition: partition,
  flatMap: flatMap,
  fromArray: fromArray,
  publish: publish
};

exports.Unsubscriber = Unsubscriber;
exports.Subscription = Subscription;
exports.Observable = Observable;
exports.Single = Single;
exports.Subject = Subject;
exports.Operators = Operators;
/* include Not a pure module */
